import { SpreadsheetMappingType, EntityType } from 'api'
import { createSelector } from '@reduxjs/toolkit'
import { createAllEntityUpdatesSelector } from './entitySelectors'
import { compareInsensitive, ParametricSelector } from 'utils'
import { SpreadsheetMappingHelper } from 'model'

export function createSortedSpreadsheetMappingsSelector<TProps>(
  spreadsheetMappingTypeSelector: ParametricSelector<{}, TProps, SpreadsheetMappingType | null | undefined> = () => null
) {
  return createSelector(
    [createAllEntityUpdatesSelector(EntityType.SPREADSHEET_MAPPING), spreadsheetMappingTypeSelector],
    (spreadsheetMappingUpdates, spreadsheetMappingType) =>
      spreadsheetMappingUpdates
        .filter(update => !spreadsheetMappingType || update.entity.type === spreadsheetMappingType)
        .sort((update1, update2) =>
          compareInsensitive(SpreadsheetMappingHelper.getName(update1.entity), SpreadsheetMappingHelper.getName(update2.entity))
        )
        .map(update => update.entity)
  )
}

export function createSortedSpreadsheetMappingIdsSelector<TProps>(
  spreadsheetMappingTypeSelector: ParametricSelector<{}, TProps, SpreadsheetMappingType | null | undefined> = () => null
) {
  return createSelector(createSortedSpreadsheetMappingsSelector(spreadsheetMappingTypeSelector), spreadsheetMappings =>
    spreadsheetMappings.map(mapping => mapping.id)
  )
}
